<uni-search
  [showOptions]="true"
  placeholder="Search Jouranls on UNI"
  (filter)="openFilterDialog()"
  (sort)="openSortDialog()"
  (searchedText)="addSearchText($event)"
  [orderTitle]="orderTitle">
</uni-search>

<div fxLayout="row" class="relative margin-y-3">
  <section
    class="width-100 overflow-hidden"
    fxLayout="row"
    [ngStyle]="{ padding: showScroll ? '0 60px' : '0' }"
    #tabsContent>
    <div #chipSection>
      <mat-chip-list #chipList aria-label="Search results" class="search-chip-list">
        <mat-chip
          *ngFor="let query of searchQuery"
          [selectable]="selectable"
          [removable]="removable"
          class="chip-section sparro-grey-900">
          {{ query | titlecase }}
          <i class="icon-cross font-sm" (click)="removeSearchText(query)" *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngFor="let discipline of selectedDisciplines"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeDiscipline(discipline)"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800" *ngIf="discipline?.name">Discipline: </span>
            {{ discipline.name | titlecase }}
          </p>
          <i
            class="icon-cross font-sm"
            (click)="removeDiscipline(discipline)"
            *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngFor="let journalType of selectedJournalTypes"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeJournalType(journalType)"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800" *ngIf="journalType?.name"
              >Journal type:
            </span>
            {{ journalType.name | titlecase }}
          </p>
          <i
            class="icon-cross font-sm"
            (click)="removeJournalType(journalType)"
            *ngIf="removable"></i>
        </mat-chip>
        <mat-chip
          *ngIf="selectedRange"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeDateRange()"
          class="chip-section sparro-grey-900">
          <p class="margin-0">
            <span class="mat-chip-head sparro-grey-800">Date Range: </span> {{ selectedRange }} ({{
              dateRange
            }})
          </p>
          <i class="icon-cross font-sm" (click)="removeDateRange()" *ngIf="removable"></i>
        </mat-chip>
      </mat-chip-list>
    </div>
  </section>
  <div class="absolute cursor-pointer height-100" fxLayout="row" style="left: 0" *ngIf="showScroll">
    <i
      class="icon-arrow-left-bold sparro-grey-700"
      style="background: #f4f4f4; font-size: 32px; line-height: 48px"
      (click)="scroll('left')"></i>
    <div
      class=""
      style="
        background: linear-gradient(to right, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%);
        width: 32px;
      "></div>
  </div>
  <div
    class="absolute cursor-pointer height-100"
    fxLayout="row"
    style="right: 0"
    *ngIf="showScroll">
    <div
      class=""
      style="
        background: linear-gradient(to left, rgba(244, 244, 244, 1) 46%, rgba(0, 0, 0, 0) 80%);
        width: 32px;
      "></div>
    <i
      class="icon-arrow-right-bold sparro-grey-700"
      style="background: #f4f4f4; font-size: 32px; line-height: 48px"
      (click)="scroll('right')"></i>
  </div>
</div>

<section class="blog-card-section">
  <ng-container *ngIf="isLoading; else viewTemplate">
    <div fxLayout="row" fxLayoutAlign="center center" class="height-75vh">
      <uni-loader></uni-loader>
    </div>
  </ng-container>

  <ng-template #viewTemplate>
    <ng-container *ngIf="filteredResults && filteredResults.length > 0; else noBlogs">
      <div fxLayout="row" fxLayoutAlign="center center" class="margin-top-4">
        <h1 class="margin-0 font-bold font-sm">
          Showing {{ searchResults }} of {{ totalCount }} search results
        </h1>
      </div>
      <div class="margin-top-8">
        <uni-blog-cards-group [blogs]="filteredResults" [dialogOpenable]="false">
        </uni-blog-cards-group>
      </div>
    </ng-container>
    <ng-template #noBlogs>
      <div class="height-75vh" fxLayout="row" fxLayoutAlign="center center">
        <p class="not-found-text">Nothing related found. Please search something else!</p>
      </div>
    </ng-template>
  </ng-template>

  <ng-container *ngIf="showSpinner">
    <div fxLayout="row" fxLayoutAlign="center center" class="height-100">
      <uni-loader></uni-loader>
    </div>
  </ng-container>
</section>

<uni-public-footer></uni-public-footer>
